import { TextField } from '@hypeit-gmbh/hypeit-ui';
import { Grid, TextInputProps } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { DEFAULT_SPAN, TRANS_KEY, useAddressPrefix } from '../Root';

type StreetProps = {
  span?: number;
} & TextInputProps;

export const Street: React.FC<StreetProps> = ({ span, ...props }) => {
  const { t } = useTranslation();
  const prefix = useAddressPrefix();

  return (
    <Grid.Col span={span ?? DEFAULT_SPAN}>
      <TextField
        fieldName={`${prefix}.street`}
        label={t(`${TRANS_KEY}.STREET_LABEL`)}
        required
        {...props}
      />
    </Grid.Col>
  );
};
